export default __webpack_public_path__ + "static/media/foto.94e68a9f.jpeg";